(() => {
  const logic = {
    isGift: item => item.properties?._aty_gift === 'v2',
    discounted: item => (item.line_level_discount_allocations || []).some(allocation => Number(allocation.amount) > 0),
    qualifying(cart, giftProduct, products, includeDiscounted = false) {
      return (cart.items || []).reduce((sum, item) => {
        if (this.isGift(item) || String(item.product_id) === String(giftProduct) || item.selling_plan_allocation || (!includeDiscounted && this.discounted(item))) return sum;
        if (products && !products.map(String).includes(String(item.product_id))) return sum;
        return sum + Number(item.original_line_price ?? item.line_price ?? 0);
      }, 0);
    },
    eligible(cart, config) {
      return Boolean(config.giftEnabled && config.giftVariant && cart.currency === 'EUR' && config.giftThreshold > 0 && this.qualifying(cart, config.giftProduct, config.giftQualifyingProducts, config.giftDiscountEngine === 'app') >= config.giftThreshold);
    },
    codes(cart) {
      return [...new Set((cart.discount_codes || []).map(entry => entry.code).filter(Boolean))];
    },
    shipping(cart, config) {
      return Number(cart.currency === 'EUR' ? config.shippingEUR : cart.currency === 'USD' ? config.shippingUSD : 0);
    }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = logic;
  if (typeof document === 'undefined') return;

  function init() {
    const root = document.querySelector('[data-aty-cart]');
    const configNode = document.querySelector('[data-aty-cart-config]');
    if (!root || !configNode || root.dataset.atyReady === 'v2') return;
    root.dataset.atyReady = 'v2';
    const config = JSON.parse(configNode.textContent);
    const allowedTitles = String(config.giftVariantTitles || '').split(/\r?\n/).map(value => value.trim()).filter(Boolean);
    const choices = config.giftIsGemstones
      ? (config.giftAvailable ? [...new Set(String(config.giftGemstoneChoices || '').split(/\r?\n/).map(value => value.trim()).filter(Boolean))].map(value => ({value,variant:config.giftVariant,label:value})) : [])
      : (config.giftVariants || []).filter(variant => variant.available && (!allowedTitles.length || allowedTitles.includes(variant.title))).map(variant => ({value:String(variant.id),variant:variant.id,label:variant.title}));
    document.body.append(root);
    const $ = selector => root.querySelector(selector);
    const signalController = new AbortController();
    const signal = signalController.signal;
    const panel = $('[data-aty-cart-panel]');
    const base = window.Shopify?.routes?.root || '/';
    let state = null, queue = Promise.resolve(), pending = 0, lastFocus = null, closeTimeout, timerInterval;
    let giftFailed = false, giftDismissed = false, deadline = 0, timerKey = '';
    let giftChoice = '', allowCheckout = false;
    const t = (key, amount) => (config.text[key] || key).replace('__amount__', amount || '');
    const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:state?.currency || 'EUR',minimumFractionDigits:Number(amount) % 100 === 0 ? 0 : 2,maximumFractionDigits:2}).format(amount / 100);
    const storage = {
      get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
      set(key, value) { try { sessionStorage.setItem(key, value); } catch {} },
      remove(key) { try { sessionStorage.removeItem(key); } catch {} }
    };
    const choiceKey = cart => 'aty-gift-choice:' + cart.token + ':' + config.giftProduct;
    const selectedChoice = () => choices.find(choice => choice.value === giftChoice);
    const needsChoice = () => Boolean(state && !giftFailed && choices.length && logic.eligible(state, config) && !state.items.some(item => logic.isGift(item) && item.final_line_price === 0));
    function selectionError() {
      const card = $('[data-aty-gift-card]'), select = $('[data-aty-gift-choice]');
      $('[id=aty-gift-error]').hidden = false;
      $('[id=aty-gift-error]').textContent = t('gift_required');
      select.setAttribute('aria-invalid','true');
      card.classList.remove('has-error');
      void card.offsetWidth;
      card.classList.add('has-error');
      card.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      requestAnimationFrame(() => select.focus({preventScroll:true}));
    }
    $('[data-aty-gift-choice]').innerHTML += choices.map(choice => `<option value="${esc(choice.value)}">${esc(choice.label)}</option>`).join('');
    function error(message = '') {
      $('[data-aty-err]').textContent = message;
      $('[data-aty-err]').hidden = !message;
    }
    async function api(endpoint, body) {
      const response = await fetch(base + endpoint, {
        signal:AbortSignal.timeout(20000),
        method:body === undefined ? 'GET' : 'POST',
        headers:{Accept:'application/json', ...(body instanceof FormData || body === undefined ? {} : {'Content-Type':'application/json'})},
        ...(body === undefined ? {} : {body:body instanceof FormData ? body : JSON.stringify(body)})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || t('error'));
      return data;
    }
    function busy() {
      const active = pending > 0;
      root.setAttribute('aria-busy', String(active));
      $('[data-aty-busy]').hidden = !active;
      root.querySelectorAll('[data-aty-step], [data-aty-remove], [data-aty-add], [data-aty-gift-claim], [data-aty-gift-choice], [data-aty-discount-form] button, [data-aty-remove-code], .aty-cart__checkout').forEach(el => el.disabled = active);
      const missingChoice = needsChoice();
      $('.aty-cart__wallets')?.toggleAttribute('inert', active || missingChoice);
      if ($('.aty-cart__wallets')) $('.aty-cart__wallets').hidden = missingChoice;
      $('[data-aty-wallet-hint]').hidden = !missingChoice;
    }
    function run(task) {
      pending++;
      busy();
      queue = queue.then(task).catch(err => error(err.message || t('error'))).finally(() => { pending--; busy(); });
      return queue;
    }
    async function reconcile(cart, claim = false) {
      let managed = cart.items.filter(logic.isGift);
      const savedChoice = storage.get(choiceKey(cart));
      const existingChoice = managed[0] && (config.giftIsGemstones ? managed[0].properties?.['Gemstone set 1'] : String(managed[0].variant_id));
      giftChoice = choices.some(choice => choice.value === savedChoice) ? savedChoice : choices.some(choice => choice.value === existingChoice) ? existingChoice : '';
      const selected = selectedChoice();
      const eligible = logic.eligible(cart, config);
      if (!eligible) {
        giftDismissed = false;
        storage.remove('aty-gift-dismissed:' + cart.token);
      } else giftDismissed = storage.get('aty-gift-dismissed:' + cart.token) === '1';
      const wanted = eligible && selected && !giftDismissed && !giftFailed && (config.giftMode === 'auto' || claim || managed.length);
      const matches = item => String(item.variant_id) === String(selected?.variant) && (!config.giftIsGemstones || item.properties?.['Gemstone set 1'] === selected?.value);
      let obsolete = cart.items.find(item => logic.isGift(item) && (!wanted || !matches(item)));
      while (obsolete) {
        cart = await api('cart/change.js', {id:obsolete.key,quantity:0});
        obsolete = cart.items.find(item => logic.isGift(item) && (!wanted || !matches(item)));
      }
      managed = cart.items.filter(logic.isGift);
      if (!wanted) return cart;
      while (cart.items.filter(logic.isGift).length > 1) {
        cart = await api('cart/change.js', {id:cart.items.filter(logic.isGift).at(-1).key,quantity:0});
      }
      let gift = cart.items.find(logic.isGift);
      if (!gift) {
        await api('cart/add.js', {items:[{id:Number(selected.variant),quantity:1,properties:{_aty_gift:'v2',...(config.giftIsGemstones ? {'Gemstone set 1':selected.value} : {})}}]});
        cart = await api('cart.js');
      } else if (gift.quantity !== 1) {
        cart = await api('cart/change.js', {id:gift.key,quantity:1});
      }
      gift = cart.items.find(logic.isGift);
      if (gift && gift.final_line_price !== 0) {
        cart = await api('cart/change.js', {id:gift.key,quantity:0});
        giftFailed = true;
        error(t('gift_configuration'));
      }
      return cart;
    }
    async function refresh(claim = false) {
      let cart = await api('cart.js');
      try { cart = await reconcile(cart, claim); }
      catch (err) {
        giftFailed = true;
        error(err.message || t('gift_configuration'));
        cart = await api('cart.js');
        let paidGift = cart.items.find(item => logic.isGift(item) && item.final_line_price !== 0);
        while (paidGift) {
          cart = await api('cart/change.js', {id:paidGift.key,quantity:0});
          paidGift = cart.items.find(item => logic.isGift(item) && item.final_line_price !== 0);
        }
      }
      render(cart);
    }
    function open() {
      clearTimeout(closeTimeout);
      if (root.hidden) lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('aty-cart-open');
      requestAnimationFrame(() => { root.classList.add('is-open'); $('button[data-aty-cart-close]').focus(); });
    }
    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('aty-cart-open');
      closeTimeout = setTimeout(() => { root.hidden = true; }, 260);
      lastFocus?.focus?.();
    }
    function image(productId, fallback) { return config.images[String(productId)] || fallback; }
    function itemMarkup(item) {
      const gift = logic.isGift(item) && item.final_line_price === 0;
      const src = image(item.product_id, item.image || item.featured_image?.url);
      const properties = Object.entries(item.properties || {}).filter(([key,value]) => key[0] !== '_' && value).map(([key,value]) => `<span class="aty-cart__prop">${esc(key)}: ${esc(value)}</span>`).join('');
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span class="aty-cart__variant">${esc(item.variant_title)}</span>` : '';
      const sellingPlan = item.selling_plan_allocation?.selling_plan?.name;
      return `<div class="aty-cart__item" data-key="${esc(item.key)}"><a class="aty-cart__art" href="${esc(item.url)}">${src ? `<img src="${esc(src)}" alt="${esc(item.product_title)}" width="160" height="160" loading="lazy">` : ''}</a><div class="aty-cart__meta"><a class="aty-cart__name" href="${esc(item.url)}">${esc(item.product_title)}</a>${variant}${sellingPlan ? `<span class="aty-cart__prop">${esc(sellingPlan)}</span>` : ''}${properties}${gift ? `<span class="atyc-gift-tag">${esc(t('gift_tag'))}</span>` : `<div class="aty-cart__qty"><button type="button" data-aty-step="-1" aria-label="${esc(t('less'))}">−</button><span>${item.quantity}</span><button type="button" data-aty-step="1" aria-label="${esc(t('more'))}">+</button></div>`}</div><div class="aty-cart__right"><button type="button" class="aty-cart__remove" data-aty-remove aria-label="${esc(t('remove'))}">×</button><span class="aty-cart__price">${item.original_line_price > item.final_line_price ? `<s>${esc(money(item.original_line_price))}</s> ` : ''}${esc(money(item.final_line_price))}</span></div></div>`;
    }
    function rewards(cart) {
      const shipping = logic.shipping(cart, config);
      const gifts = Boolean(config.giftEnabled && config.giftVariant && cart.currency === 'EUR' && config.giftThreshold > 0);
      const show = cart.item_count > 0 && (shipping > 0 || gifts);
      $('[data-aty-rewards]').hidden = !show;
      if (!show) return;
      const max = Math.max(shipping, gifts ? config.giftThreshold : 0);
      const shippingStep = $('[data-aty-shipping-step]'), giftStep = $('[data-aty-gift-step]');
      shippingStep.hidden = shipping <= 0;
      giftStep.hidden = !gifts;
      const shipDone = shipping > 0 && cart.total_price >= shipping;
      const giftDone = logic.eligible(cart, config);
      const spendReached = cart.total_price >= config.giftThreshold || giftDone;
      const hasGift = cart.items.some(item => logic.isGift(item) && item.final_line_price === 0);
      shippingStep.style.setProperty('--step', shipping / max * 100 + '%');
      giftStep.style.setProperty('--step', config.giftThreshold / max * 100 + '%');
      shippingStep.classList.toggle('is-earned', shipDone);
      giftStep.classList.toggle('is-earned', spendReached);
      $('[data-aty-shipping-value]').textContent = money(shipping);
      $('[data-aty-gift-value]').textContent = money(config.giftThreshold);
      const progress = Math.max(Math.min(100, cart.total_price / max * 100), shipDone ? shipping / max * 100 : 0, gifts && giftDone ? config.giftThreshold / max * 100 : 0);
      requestAnimationFrame(() => $('[data-aty-reward-fill]').style.width = Math.min(100, progress) + '%');
      const messages = [];
      if (shipping > 0) messages.push(shipDone ? t('shipping_done') : t('shipping_left', money(Math.max(0, shipping - cart.total_price))));
      if (gifts) messages.push(giftFailed ? t('gift_configuration') : !config.giftQualifyingProducts?.length ? t('gift_scope') : hasGift ? t('gift_added') : !choices.length ? t('gift_unavailable') : giftDone ? t('gift_choose') : spendReached && config.giftDiscountEngine !== 'app' && cart.items.some(item => logic.discounted(item) && config.giftQualifyingProducts.map(String).includes(String(item.product_id))) ? t('gift_conflict') : t('gift_left', money(Math.max(0, config.giftThreshold - logic.qualifying(cart, config.giftProduct, config.giftQualifyingProducts, config.giftDiscountEngine === 'app')))));
      $('[data-aty-reward-message]').textContent = messages.join(' ');
      $('[data-aty-gift-card]').hidden = !(gifts && giftDone && choices.length && !giftFailed);
      $('[data-aty-gift-choice]').value = giftChoice;
      $('[id=aty-gift-hint]').hidden = hasGift;
      $('[data-aty-gift-basis]').hidden = hasGift || config.giftDiscountEngine !== 'app';
      $('[data-aty-gift-claim]').hidden = !(gifts && giftDone && !hasGift && (config.giftMode === 'claim' || giftDismissed));
      if (hasGift || !giftDone) {
        $('[id=aty-gift-error]').hidden = true;
        $('[data-aty-gift-choice]').removeAttribute('aria-invalid');
        $('[data-aty-gift-card]').classList.remove('has-error');
      }
    }
    function countdown(cart) {
      const wrap = $('[data-aty-timer]');
      if (!wrap) return;
      wrap.hidden = !cart.item_count;
      clearInterval(timerInterval);
      if (!cart.item_count) {
        if (timerKey) storage.remove(timerKey);
        deadline = 0;
        return;
      }
      const key = 'aty-cart-timer:' + String(cart.token || 'current').split('?')[0];
      if (timerKey !== key || !deadline) {
        timerKey = key;
        const saved = Number(storage.get(key));
        deadline = saved > 0 ? saved : Date.now() + config.timerMinutes * 60000;
        storage.set(key, String(deadline));
      }
      function tick() {
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        $('[data-aty-time]').textContent = `${String(Math.floor(remaining / 60)).padStart(2,'0')}:${String(remaining % 60).padStart(2,'0')}`;
        $('[data-aty-time]').hidden = remaining === 0;
        $('[data-aty-timer-note]').hidden = remaining === 0;
        $('[data-aty-timer-label]').textContent = t(remaining ? 'timer' : 'timer_expired');
        if (!remaining) clearInterval(timerInterval);
      }
      tick();
      if (deadline > Date.now()) timerInterval = setInterval(tick, 1000);
    }
    function renderCodes(cart) {
      const list = $('[data-aty-codes]');
      if (!list) return;
      list.innerHTML = logic.codes(cart).map(code => `<li><span>${esc(code)}</span><button type="button" data-aty-remove-code="${esc(code)}" aria-label="${esc(t('code_remove'))}">×</button></li>`).join('');
    }
    function render(cart) {
      state = cart;
      const empty = !cart.items.length;
      const active = document.activeElement;
      const focusedRow = active?.closest('[data-key]');
      const focusedItem = focusedRow && state.items.find(item => item.key === focusedRow.dataset.key);
      const focusVariant = focusedItem?.variant_id;
      const step = active?.dataset?.atyStep;
      $('[data-aty-items]').innerHTML = cart.items.map(itemMarkup).join('');
      if (focusVariant && step) {
        const next = cart.items.find(item => item.variant_id === focusVariant);
        const row = [...root.querySelectorAll('[data-key]')].find(el => el.dataset.key === next?.key);
        row?.querySelector(`[data-aty-step="${step}"]`)?.focus();
      }
      $('[data-aty-empty]').hidden = !empty;
      $('[data-aty-foot]').hidden = empty;
      $('[data-aty-total]').textContent = money(cart.total_price);
      $('[data-aty-kit-guide]').hidden = !cart.items.some(item => item.handle === 'silver-clay-kit');
      const savings = $('[data-aty-savings]');
      savings.hidden = !(cart.total_discount > 0);
      savings.textContent = t('saved') + ' ' + money(cart.total_discount || 0);
      const upsell = $('[data-aty-upsell]');
      if (upsell) {
        upsell.hidden = empty || cart.items.some(item => String(item.variant_id) === String(config.upsellVariant));
        const src = image(config.upsellProduct, config.upsellImage);
        $('[data-aty-upsell-image]').innerHTML = src ? `<img src="${esc(src)}" alt="" width="160" height="160" loading="lazy">` : '';
      }
      document.querySelectorAll('[data-aty-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      document.querySelectorAll('[data-aty-cart-open]').forEach(el => el.setAttribute('aria-label', t('cart_label').replace('__count__', cart.item_count)));
      rewards(cart);
      countdown(cart);
      renderCodes(cart);
      busy();
      document.dispatchEvent(new CustomEvent('atelaye:cart-rendered', {detail:{cart}}));
    }
    document.addEventListener('click', event => {
      if (!event.target.closest('[data-aty-cart-open]')) return;
      event.preventDefault();
      open();
      run(() => refresh());
    }, {signal});
    root.addEventListener('click', event => {
      const target = event.target;
      if (target.closest('[data-aty-cart-close]')) { event.preventDefault(); close(); return; }
      const row = target.closest('[data-key]');
      const step = target.closest('[data-aty-step]'), remove = target.closest('[data-aty-remove]');
      if (row && (step || remove)) {
        const item = state?.items.find(item => item.key === row.dataset.key);
        if (!item) return;
        const variant = item.variant_id, properties = JSON.stringify(item.properties || {}), sellingPlan = item.selling_plan_allocation?.selling_plan?.id;
        run(async () => {
          error();
          const cart = await api('cart.js');
          const fresh = cart.items.find(line => line.variant_id === variant && JSON.stringify(line.properties || {}) === properties && line.selling_plan_allocation?.selling_plan?.id === sellingPlan);
          if (!fresh) return refresh();
          if (remove && logic.isGift(fresh)) {
            giftDismissed = true;
            storage.set('aty-gift-dismissed:' + cart.token, '1');
          }
          await api('cart/change.js', {id:fresh.key,quantity:remove ? 0 : Math.max(0, fresh.quantity + Number(step.dataset.atyStep))});
          await refresh();
        });
      }
      if (target.closest('[data-aty-add]')) run(async () => { error(); await api('cart/add.js', {items:[{id:Number(config.upsellVariant),quantity:1}]}); await refresh(); });
      if (target.closest('[data-aty-gift-claim]')) {
        if (!selectedChoice()) selectionError();
        else run(async () => { giftFailed = false; giftDismissed = false; storage.remove('aty-gift-dismissed:' + state.token); await refresh(true); });
      }
      const codeRemove = target.closest('[data-aty-remove-code]');
      if (codeRemove) run(async () => {
        const cart = await api('cart.js');
        const codes = logic.codes(cart).filter(code => code.toLowerCase() !== codeRemove.dataset.atyRemoveCode.toLowerCase());
        await api('cart/update.js', {discount:codes.join(',')});
        await refresh();
        $('[data-aty-code-message]').textContent = t('code_removed');
      });
    }, {signal});
    $('[data-aty-gift-choice]').addEventListener('change', event => {
      giftChoice = event.target.value;
      storage.set(choiceKey(state), giftChoice);
      giftFailed = false;
      storage.remove('aty-gift-dismissed:' + state.token);
      $('[id=aty-gift-error]').hidden = true;
      event.target.removeAttribute('aria-invalid');
      $('[data-aty-gift-card]').classList.remove('has-error');
      run(async () => { error(); await refresh(true); });
    }, {signal});
    $('[data-aty-discount-form]')?.addEventListener('submit', event => {
      event.preventDefault();
      const input = event.target.elements.discount;
      const code = input.value.trim();
      if (!code) return;
      run(async () => {
        error();
        const cart = await api('cart.js');
        const codes = logic.codes(cart).filter(value => value.toLowerCase() !== code.toLowerCase());
        const updated = await api('cart/update.js', {discount:[...codes,code].join(',')});
        await refresh();
        const result = state.discount_codes?.find(entry => entry.code.toLowerCase() === code.toLowerCase()) || updated.discount_codes?.find(entry => entry.code.toLowerCase() === code.toLowerCase());
        $('[data-aty-code-message]').textContent = t(result?.applicable === true ? 'code_applied' : 'code_pending');
        input.value = '';
      });
    }, {signal});
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !(form.getAttribute('action') || '').includes('/cart/add')) return;
      event.preventDefault();
      event.stopPropagation();
      const data = new FormData(form);
      const submitter = event.submitter || form.querySelector('[type="submit"]');
      if (submitter?.disabled) return;
      if (submitter) submitter.disabled = true;
      open();
      run(async () => {
        try { error(); await api('cart/add.js', data); await refresh(); }
        finally { if (submitter) submitter.disabled = false; }
      });
    }, {capture:true,signal});
    $('#aty-cart-checkout')?.addEventListener('submit', event => {
      if (allowCheckout) { allowCheckout = false; return; }
      event.preventDefault();
      if (pending) return;
      const form = event.target;
      run(async () => {
        if (selectedChoice() && state) storage.remove('aty-gift-dismissed:' + state.token);
        await refresh(true);
        if (needsChoice()) { selectionError(); return false; }
        if (state?.items.some(item => logic.isGift(item) && item.final_line_price > 0)) return false;
        return true;
      }).then(proceed => {
        if (!proceed) return;
        allowCheckout = true;
        form.requestSubmit(form.querySelector('[name=checkout]'));
      });
    }, {signal});
    document.addEventListener('keydown', event => {
      if (root.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')].filter(el => el.getClientRects().length && !el.closest('[hidden],[inert]'));
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }, {signal});
    document.addEventListener('cart:update', event => { run(() => refresh()); if (event.detail?.data?.source === 'product-form-component') open(); }, {signal});
    window.addEventListener('pageshow', event => { if (event.persisted) run(() => refresh()); }, {signal});
    window.addEventListener('focus', () => { if (!root.hidden) run(() => refresh()); }, {signal});
    const seed = document.querySelector('[data-aty-cart-initial]');
    if (seed) { try { render(JSON.parse(seed.textContent)); } catch { run(() => refresh()); } }
    if (config.giftEnabled) run(() => refresh());
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(configNode)) return;
      signalController.abort(); clearInterval(timerInterval); clearTimeout(closeTimeout); root.remove(); document.documentElement.classList.remove('aty-cart-open');
    }, {signal});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
